// extracted by mini-css-extract-plugin
export default {"Tooltip":"DashboardTooltip_Tooltip__SD2sw","TooltipContent":"DashboardTooltip_TooltipContent__pZkA+","Content":"DashboardTooltip_Content__illTH"};